import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Plus, Sparkles } from 'lucide-react';
import Button from '@/components/primitives/Button.jsx';
import EmptyState from '@/components/patterns/EmptyState.jsx';
import PageHeader from '@/components/patterns/PageHeader.jsx';
import RowList from '@/components/patterns/RowList.jsx';
import formatUpdatedOn from '@/lib/knowledge/formatUpdatedOn.js';
import { availableKnowledgeSkillItems } from '@/redux/selectors/pieveSelectors/sidebarSkillSelectors.js';

/** Every skill Pieve can follow, by name, with when each one is used. */
const SkillsPage = () => {
  const navigate = useNavigate();
  const skills = useSelector(availableKnowledgeSkillItems);
  const newSkill = (
    <Button variant="primary" iconStart={Plus} onClick={() => navigate('/skills/new')}>
      New skill
    </Button>
  );

  return (
    <div className="comp-page">
      <PageHeader title="Skills" description="Instructions Pieve follows for a kind of work you repeat, written once and reused in every conversation." actions={skills.length > 0 ? newSkill : null} />
      {skills.length === 0 ? (
        <EmptyState icon={Sparkles} title="No skills yet" description="Write down how you like a task done, and Pieve follows it whenever that task comes up. You can also ask Pieve to save one from a conversation." action={newSkill} />
      ) : (
        <RowList
          label="Skills"
          items={skills.map((skill) => ({
            id: skill.id,
            to: `/skills/${skill.id}`,
            title: skill.meta?.title || skill.meta?.slug,
            description: skill.meta?.description,
            note: formatUpdatedOn(skill.updatedOn)
          }))}
        />
      )}
    </div>
  );
};

export default SkillsPage;
